import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_18721045 from "../../../../../packages/component/src/components/split-button/demo/demo1.js?loadDemo";
import legacyImportDemo_1560546998 from "../../../../../packages/component/src/components/split-button/demo/demo2.js?loadDemo";
import legacyImportDemo_1271984983 from "../../../../../packages/component/src/components/split-button/demo/demo3.js?loadDemo";
import legacyImportDemo_3859385840 from "../../../../../packages/component/src/components/split-button/demo/demo4.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_18721045,
  legacyImportDemo_1560546998,
  legacyImportDemo_1271984983,
  legacyImportDemo_3859385840,
  React
};